<template>
<!-- 直播管理 -->
<section class="viewContainer">
  <div v-if="isShowzbj">
    <el-tabs type="card" v-model="zbradio" @tab-click="changezb">
      <el-tab-pane label="直播间" name='first'/>
      <el-tab-pane label="直播商品库" name='second'/>
    </el-tabs>
    <!-- 直播间 -->
    <div v-if="zbradio=='first'">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
        </div>
        <el-collapse-transition>
          <div v-show="show3">
            <el-form class="findform">
              <el-form-item label="直播间标题：" style="display:flex;width:30%">
                <el-input v-model="zbjbt" placeholder="请输入直播间标题" maxlength="20" style="width:90%;"/>
              </el-form-item>
              <el-form-item label="开播时间：" style="display:flex;width:30%">
                <el-date-picker type="daterange" v-model="valuedate" :title="valuedate" @change="changetimeOne" style="width:90%;"
                value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
              </el-form-item>
              <el-form-item label="状态：" style="display:flex;width:30%">
                <el-select v-model="ztId" filterable placeholder="请选择" style="width:90%;">
                  <el-option v-for="(item,index) in ztArr" :key="index" :label="item.Name" :value="item.Id"/>
                </el-select>
              </el-form-item>
              <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
      <div class="main_container">
        <section class="model_section">
          <p class="model_top_title">直播间</p>
          <el-button type="danger" @click="cjbjzbj()" style="float: right;margin: 6px 10px 0 0;">创建直播间</el-button>
        </section>
        <div class="table_container">
          <el-table :data="zbjList" stripe border>
            <el-table-column label="序号" align="center" width="68px">
              <template scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column label="房间号" align="center" width="120px">
              <template scope="scope">{{scope.row.wxroomid}}</template>
            </el-table-column>
            <el-table-column label="直播间标题" align="center">
              <template scope="scope">{{scope.row.title}}</template>
            </el-table-column>
            <el-table-column label="开播时间" align="center">
              <template scope="scope">{{scope.row.livetime}}</template>
            </el-table-column>
            <el-table-column label="直播状态" align="center">
              <template scope="scope">{{scope.row.statusname}}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center">
              <template scope="scope">
                <span @click="handlekzt(scope.row)" class="handle"><i class="el-icon-monitor"/> 控制台</span>
                <span @click="handlekbm(scope.row)" class="handle" v-show="scope.row.status != 103"><i class="el-icon-data-analysis"/> 开播码</span>
                <span @click="handlefx(scope.row)" class="handle"><i class="el-icon-share"></i> 分享</span>
                <span @click="cjbjzbj(scope.row)" class="handle" v-show="scope.row.status == 102">
                  <i class="el-icon-edit-outline"/> 编辑
                </span>
                <span @click="deleteBrand(scope.row,1)" class="handle" v-show="scope.row.status != 101">
                  <i class="el-icon-delete"></i> 删除
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" @current-change="changezbjcurrent"
          :current-page="pagezbjindex" :page-size="10" :total="zbjtotal" style="margin:10px 0;text-align:right;"/>
        </div>
      </div>
    </div>
    <!-- 直播商品库 -->
    <div v-else>
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
        </div>
        <el-collapse-transition>
          <div v-show="show3">
            <el-form class="findform">
              <el-form-item style="display:flex;width:30%" label="商品名称：">
                <el-input v-model="channelName" placeholder="请输入商品名称 (20字以内)" maxlength="20" style="width:90%"/>
              </el-form-item>
              <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
      <div class="main_container">
        <section class="model_section">
          <p class="model_top_title">直播商品库</p>
          <el-button type="danger" @click="addOrEditBrand()" style="float: right;margin: 6px 10px 0 0;">添加商品</el-button>
        </section>
        <div class="table_container">
          <el-table :data="zbspkList" stripe border>
            <el-table-column label="序号" align="center" width="68px">
              <template scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column label="商品名称" align="center">
              <template scope="scope">{{scope.row.goodsname}}</template>
            </el-table-column>
            <el-table-column label="价格" align="center">
              <template scope="scope">{{scope.row.price}}</template>
            </el-table-column>
            <!-- <el-table-column label="创建人" align="center">
              <template scope="scope">{{scope.row.cjr}}</template>
            </el-table-column> -->
            <el-table-column label="状态" align="center">
              <template scope="scope">{{scope.row.statusname}}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center">
              <template scope="scope">
                <span @click="cardStatus(scope.row)" class="handle" v-if="scope.row.status != 2">
                  <i :class="scope.row.status == 1?'el-icon-circle-close':'el-icon-circle-check'"/>
                  {{scope.row.status == 1?"撤销审核":"提交审核"}}
                </span>
                <span @click="addOrEditBrand(scope.row, 1)" class="handle" v-if="scope.row.status == 0||scope.row.status == 3">
                  <i class="el-icon-edit-outline"/> 编辑
                </span>
                <span @click="addOrEditBrand(scope.row, 2)" class="handle" v-if="scope.row.status == 2">修改价格</span>
                <span @click="deleteBrand(scope.row,2)" class="handle" v-show="scope.row.status != 1">
                  <i class="el-icon-delete"></i> 删除
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page="pagezbspkindex" :page-size="10" :total="zbspktotal" style="margin:10px 0;text-align:right;"/>
        </div>
      </div>
    </div>
  </div>

  <!-- 创建直播间 -->
  <div v-else class="main_container">
    <h3 style="margin-left: 20px;">直播间信息</h3>
    <el-row style="padding: 10px 0 0 20px;">
    <el-col :span="12">
    <el-form>
      <el-form-item label="直播间标题：" style="width:80%;" label-width="100px">
        <el-input v-model="zhibojianbt" placeholder="请输入3-17汉字的标题" maxlength="17" style="width:80%"/>
      </el-form-item>
      <el-form-item label="开播时间：" style="width:80%;" label-width="100px">
        <el-date-picker type="datetimerange" v-model="kbTime" align="right" @change="changetimeTwo" value-format="yyyy-MM-dd HH:mm:ss"
        start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['08:00:00', '08:00:00']"
        style="width:80%;background: #fff;border:1px solid #eee;" :picker-options="pickerOptions"/>
      </el-form-item>
      <el-form-item label="主播昵称：" style="width:80%;" label-width="100px">
        <el-input v-model="zhubonc" placeholder="请输入2-15汉字的昵称" maxlength="15" style="width:80%"/>
      </el-form-item>
      <el-form-item label="主播微信号：" style="width:80%;" label-width="100px">
        <el-input v-model="zhubowxh" placeholder="请输入主播微信号" maxlength="50" style="width:69%">
        <i slot="suffix" class="el-input__icon el-icon-success" style="color: #5cbb7a;" v-show="verificationsuccessOne"></i>
        <i slot="suffix" class="el-input__icon el-icon-error" style="color: #F56C6C;" v-show="validationfailedOne"></i>
        </el-input>
        <el-button type="danger" @click="testing(zhubowxh,1)">验证</el-button>
      </el-form-item>
      <el-form-item label="副播微信号：" style="width:80%;" label-width="100px">
        <el-input v-model="fubowxh" placeholder="请输入副播微信号" maxlength="50" style="width:69%">
        <i slot="suffix" class="el-input__icon el-icon-success" style="color: #5cbb7a;" v-show="verificationsuccessTwo"></i>
        <i slot="suffix" class="el-input__icon el-icon-error" style="color: #F56C6C;" v-show="validationfailedTwo"></i>
        </el-input>
        <el-button type="danger" @click="testing(fubowxh,2)">验证</el-button>
        <!-- @blur="bluryzTwo" -->
      </el-form-item>
      <el-form-item label="实名认证码：" style="margin-top: -15px;" label-width="100px">
        <p style="line-height: 0;color: #F56C6C;"><i class="el-icon-warning-outline"/> 主(副)播需要实名认证，请先用微信扫码进行实名认证后，再进行验证。</p>
        <img src="../../assets/img/zbsmrz.png" style="width: 100px;"/>
      </el-form-item>
    </el-form>
    </el-col>
    <el-col :span="12">
      <div style="display: flex;margin-bottom: 10px;">
        <el-upload class="avatar-uploader" action :before-upload="(file)=>beforUploadThree(file, 1)">
          <img :src="zbjbjUrl" style="width: 80px; height: 80px;" v-if="zbjbjUrl"/>
          <i class="el-icon-plus upBtn" v-if="!zbjbjUrl"></i>
        </el-upload>
        <p style="margin-left: 10px;margin-top: 0;"><b>直播间背景：</b><br>建议像素600*1300，大小不超过 3M，格式JPG</p>
      </div>
      <div style="display: flex;margin-bottom: 10px;">
        <el-upload class="avatar-uploader" action :before-upload="(file)=>beforUploadThree(file, 2)">
          <img :src="fxtpUrl" style="width: 80px; height: 80px;" v-if="fxtpUrl"/>
          <i class="el-icon-plus upBtn" v-if="!fxtpUrl"></i>
        </el-upload>
        <p style="margin-left: 10px;margin-top: 0;"><b>分享图片：</b><br>建议像素800*640，大小不超过1M,格式JPG</p>
      </div>
      <div style="display: flex;margin-bottom: 10px;">
        <el-upload class="avatar-uploader" action :before-upload="(file)=>beforUploadThree(file, 3)">
          <img :src="sltpUrl" style="width: 80px; height: 80px;" v-if="sltpUrl"/>
          <i class="el-icon-plus upBtn" v-if="!sltpUrl"></i>
        </el-upload>
        <p style="margin-left: 10px;margin-top: 0;"><b>收录图片：</b><br>建议像素800*800，大小不超过100KB,格式JPG</p>
      </div>
      <div style="margin-bottom: 10px;">
        <div style="margin-bottom: 10px;"><b>直播间功能：</b><span>以下五个功能无法在开播后设置开启或关闭</span></div>
        <el-checkbox v-model="checkedpl">评论</el-checkbox>
        <el-checkbox v-model="checkedfx">分享</el-checkbox>
        <el-checkbox v-model="checkeddz">点赞</el-checkbox>
        <el-checkbox v-model="checkedsphj">商品货架</el-checkbox>
        <el-checkbox v-model="checkedhf">回放</el-checkbox>
      </div>
      <canvas id="canvasa" hidden/>
    </el-col>
    </el-row>
    <div v-show="isshowzbsp">
    <div style="display: flex;justify-content: space-between;padding: 0 20px;">
      <p><b>直播商品</b><span style="margin-left: 10px;">温馨提示：直播间如需配置商品，只能选择商品库审核通过的商品。</span></p>
      <el-button type="danger" @click="selectproduct()" style="height: fit-content;margin-top: 5px;">选择商品</el-button>
    </div>
    <div class="table_container">
      <el-table :data="zbcommodityList.slice((data.pageNum - 1) * data.pageSize, data.pageNum * data.pageSize)" class="invoice_tab" stripe border style="height:auto;max-height:500px">
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="商品名称" align="center">
          <template scope="scope">{{scope.row.goodsname}}</template>
        </el-table-column>
        <el-table-column label="价格" align="center">
          <template scope="scope">{{scope.row.price}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="shanchusp(scope.$index, zbcommodityList)" class="handle">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlegdChange" style="margin:10px 0;text-align:right;"
      :current-page.sync="data.pageNum" :page-size="data.pageSize" :total="zbcommodityList.length"/>
    </div>
    </div>
    <div style="text-align:center;margin: 10px 0 20px 0;">
      <el-button @click="handlezbj(2)">取消</el-button>
      <el-button type="danger" @click="handlezbj(1)" :loading="loadingBut">{{loadingButText}}</el-button>
    </div>
  </div>
  
  <!-- 新增/编辑添加商品-弹框 -->
  <el-dialog :title="commodity" :visible.sync="isToExamine" :center="true" width="30%">
    <el-form>
      <el-form-item label="选择商品 :" style="width:80%" label-width="80px" v-show="seeDis">
        <el-select v-model="stateId" filterable placeholder="请选择" style="background:#fff;width:100%" @change="changesp">
          <el-option v-for="(item,index) in statearr" :key="index" :label="item.goodsname" :value="item.shopgoodsid" />
        </el-select>
      </el-form-item>
      <el-form-item label="商品封面 :" style="width:80%;margin-bottom: 0;" label-width="80px" v-show="seeDis">
        <el-upload class="avatar-uploader" action :before-upload="(file)=>beforUploadThree(file, 4)">
          <img :src="spfmUrl" style="width: 80px; height: 80px;" v-if="spfmUrl"/>
          <i class="el-icon-plus upBtn" v-if="!spfmUrl"></i>
        </el-upload>
        <div style="color:#888;">建议尺寸：300*300，支持的图片格式：jpg、png。</div>
        <canvas id="canvasa" hidden/>
      </el-form-item>
      <el-form-item label="商品名称 :" style="width:80%" label-width="80px" v-show="seeDis">
        <el-input v-model="brandName" placeholder="请输入商品名称 (14字以内)" maxlength="14"/>
      </el-form-item>
      <el-form-item label="价格形式 :">
        <el-radio-group v-model="resource">
          <el-radio :label="1">一口价</el-radio>
          <el-radio :label="2">价格区间</el-radio>
          <el-radio :label="3">显示折扣价</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="价格 :" style="width:80%;" label-width="80px" v-show="resource == 1">
        <el-input v-model="anwser" placeholder="请输入" maxlength="10"
        onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
          <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
        </el-input>
      </el-form-item>
      <el-form-item label="价格区间 :" style="width:80%;" label-width="80px" v-show="resource == 2">
        <el-row>
          <el-col :span="12">
          <el-input v-model="jgqjOne" placeholder="请输入" maxlength="10"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
          </el-input>
          </el-col>
          <el-col :span="12">
          <el-input v-model="jgqjTwo" placeholder="请输入" maxlength="10"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
          </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="折扣区间 :" style="width:80%;" label-width="80px" v-show="resource == 3">
        <el-row>
          <el-col :span="12">
          <el-input v-model="zkqjOne" placeholder="市场价" maxlength="10"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
          </el-input>
          </el-col>
          <el-col :span="12">
          <el-input v-model="zkqjTwo" placeholder="折扣价" maxlength="10"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i>
          </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-checkbox v-model="checkedsp" v-show="seeDis">同时提交商品审核</el-checkbox>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="text-align:center">
      <el-button @click="isToExamine = false">取消</el-button>
      <el-button type="danger" @click="editSubmit()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 选择商品 -->
  <el-dialog title='选择商品' :visible.sync="shangpin" width="30%" center>
    <div style="text-align:center">
      <el-form label-width="100px" style="display:flex">
        <el-form-item label="商品名称：" style="width:50%;">
          <el-input v-model="searchsp" placeholder="请输入商品名称" maxlength="20"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="finddes()">查 询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="spList" border @selection-change="handleselection" style="width: 100%;max-height: 30vh;overflow-y: scroll;">
        <el-table-column type="selection" align="center"/>
        <el-table-column label="序号" width="60" align="center">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="goodsname" label="商品名称" align="center"/>
        <el-table-column prop="price" label="商品价格(元)" align="center"/>
      </el-table>
      <!-- <div style="width: 100%;margin-top:10px;text-align:right;">
        <el-pagination layout="prev, pager, next" @current-change="changexzsp"
        :current-page="pagexzspindex" :page-size="10" :total="spxztotal"/>
      </div> -->
    </div>
    <div style="text-align:center;margin-top: 10px;">
      <el-button @click="shangpin = false">取消</el-button>
      <el-button type="danger" @click="handlesp()">确定</el-button>
    </div>
  </el-dialog>

  <!-- 开播码-弹框 -->
  <el-dialog title="开播码" :visible.sync="kaiboma" :center="true" width="20%">
    <div style="text-align:center">
      <img :src="kbmUrl" style="width: 60%;"/>
      <div><b>小程序开播码</b></div>
      <p>微信扫码打开主播小程序</p>
      <el-button size="small" @click="handDown(kbmUrl)">保存开播码</el-button>
      <p style="color: #999;">开播码永久有效</p>
    </div>
  </el-dialog>

  <!-- 分享-弹框 -->
  <el-dialog title="分享" :visible.sync="fenxiang" width="35%">
    <el-row style="text-align:center;display: flex;justify-content: space-between;">
      <el-col :span="11" style="padding: 10px 0 10px 10px;background: #F7F7F7;">
        <el-row>
          <el-col :span="12" style="text-align: left;">
            <b>直播间分享海报</b>
            <p>小程序码不带参数</p>
            <el-button size="small" @click="handDown(fxhb)">保存图片</el-button>
          </el-col>
          <el-col :span="12">
            <img :src="fxhb" style="width: 90%;"/>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="11" style="padding: 10px 0 10px 10px;background: #F7F7F7;">
        <el-row>
          <el-col :span="12" style="text-align: left;">
            <b>直播间小程序码</b>
            <p>小程序码不带参数</p>
            <el-button size="small" @click="handDown(fxewmandkbm)">保存图片</el-button>
          </el-col>
          <el-col :span="12">
            <img :src="fxewmandkbm" style="width: 90%;"/>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-dialog>

  <!-- vueCropper 剪裁图片实现-->
  <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
    <div class="cropper-content">
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
        :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
        :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
        :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"/>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cropping = false">取 消</el-button>
      <el-button type="primary" @click="finish">确认</el-button>
    </div>
  </el-dialog>
  
  <!-- 请选择店铺 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 删除弹框 -->
  <!-- <el-button @click="showDialog">点击打开弹窗</el-button> -->
  <my-popUp ref="dialog" content="重要信息，你确定要删除吗？" @ok="onOk"/>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import MyPopUp from '../../common/popUp.vue';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, userIdentity } from '../../api/newOss';
import { roomgetlist, roomadd, roominfo, roomedit, roomdel, roomshare,
  goodsgetlist, getshopgoods, goodsadd, goodsinfo, goodsedit, goodsdel, goodsaudit, goodscancel, memberadd } from '../../api/decoration';
export default {
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      dialogVisibleadd: false, // 请选择店铺
      bbid:'',  // 店铺id
      options1: [],
      zbradio: 'first', // tab切换标识
      cardId: "", // 选中行id
      
      zbjbt: '', // 直播间标题
      valuedate: "", // 开播时间
      date1: "",
      date2: "",
      // 活动时间限制
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()-8.64e7;
        },
      },
      ztId: '', // 状态
      ztArr: [
        {
          Id: 0,
          Name: "全部"
        },{
          Id: 101,
          Name: "未开始"
        },{
          Id: 102,
          Name: "直播中"
        },{
          Id: 103,
          Name: "已结束"
        }
      ],
      zbjList: [], // 直播间列表
      pagezbjindex: 1,
      zbjtotal: 0,

      isShowzbj: true, // 创建直播间
      zhibojianbt: '', // 直播间标题
      kbTime: '', // 开播时间
      date3: "", // 开始
      date4: "", // 结束
      zhubonc: '', // 主播昵称
      zhubowxh: '', // 主播微信号
      verificationsuccessOne: false,
      validationfailedOne: false,
      fubowxh: '', // 副播微信号
      verificationsuccessTwo: false,
      validationfailedTwo: false,
      checkedpl: false, // 评论
      checkedfx: false, // 分享
      checkeddz: false, // 点赞
      checkedsphj: false, // 商品货架
      checkedhf: false, // 回放
      
      isshowzbsp: false,
      zbcommodityList: [], // 直播商品列表
      data: {
        pageNum: 1,
        pageSize: 10,
      },
      
      shangpin: false, // 选择商品弹框
      searchsp: '', // 商品名称
      spList: [], // 选择商品列表
      pagexzspindex: 1,
      spxztotal: 0,
      selectedArr:[], // 复选框选中项
      
      channelName: "", // 商品名称
      zbspkList: [], // 直播商品库列表
      pagezbspkindex: 1,
      zbspktotal: 0,

      isToExamine: false, // 添加商品弹框
      commodity: '添加商品', // 动态title
      seeDis: false, // 显隐逻辑
      stateId: '', // 选择商品
      statearr: [], // 商品集合
      brandName: "", // 商品名称
      resource: 1, // 价格形式
      anwser: '', // 价格
      jgqjOne: '', // 价格区间-前
      jgqjTwo: '', // 价格区间-后
      zkqjOne: '', // 折扣区间-前
      zkqjTwo: '', // 折扣区间-后
      checkedsp: true, // 同时提交商品审核
      zbjbjUrl: '', // 直播间背景
      zbjshortUrl: '', // 短链接
      fxtpUrl: '', // 分享图片
      fxtpshortUrl: '', // 短链接
      sltpUrl: '', // 收录图片
      sltpshortUrl: '', // 短链接
      spfmUrl: '', // 商品封面
      spfmshortUrl: '', // 短链接
      kaiboma: false, // 开播码弹框
      fenxiang: false, // 分享弹框
      kbmUrl: '', // 开播码
      fxhb: '', // 分享海报
      fxewmandkbm: '', // 分享二维码
      
      loadingBut: false,
      loadingButText: '确定',

      cropping: false, // 图片裁剪弹框
      distinguish: '', // 区分两个上传图片
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1200, // 默认生成截图框宽度
        autoCropHeight: 675, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1200, 675], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
    }
  },
  watch: {
    // 监听 商品货架
    'checkedsphj'(newV,oldV) {
      this.checkedsphj == true?this.isshowzbsp=true:this.isshowzbsp=false;
    }
  },
  components: {
    MyPopUp, // 二次确定弹框
  },
  methods: {
    showDialog() {
      this.$refs.dialog.visible = true;
    },
    onOk() {
      this.$refs.dialog.visible = false;
      this.showAlert('点击了确定按钮 删除成功', 'success');
    },
    // 切换 直播间 & 直播商品库
    changezb(val){
      this.zbradio = val.name; // tab标识
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      if(this.zbradio=='first'){
        this.pagezbjindex = 1;
        this.getinit();
      }else {
        this.pagezbspkindex = 1;
        this.productlibrary();
      }
    },
    // 直播间列表
    getinit() {
      let addParams = {
        shopid: this.bbid, // 店铺ID
        title: this.zbjbt, // 直播间标题
        bdate: this.date1, // 开始时间
        edate: this.date2, // 结束时间
        status: this.ztId, // 状态
        pageindex: this.pagezbjindex,// 分页数据 当前页码
        pagesize: 10 // 分页数据 每页显示条数
      };
      roomgetlist(addParams).then(data => {
        this.zbjList = data.resultObj.list;
        this.zbjtotal = data.resultObj.totalcount;
      }).catch(err => {
        this.zbjList = [];
        this.zbjtotal = 0;
      });
    },
    // 分页
    changezbjcurrent(val) {
      this.pagezbjindex = val;
      this.getinit();
    },
    // 直播商品库列表
    productlibrary() {
      let addParams = {
        shopid: this.bbid, // 店铺ID
        goodsname: this.channelName, // 商品名称
        pageindex: this.pagezbspkindex,// 分页数据 当前页码
        pagesize: 10 // 分页数据 每页显示条数
      };
      goodsgetlist(addParams).then(data => {
        this.zbspkList = data.resultObj.list;
        this.zbspktotal = data.resultObj.totalcount;
      }).catch(err => {
        this.zbspkList = [];
        this.zbspktotal = 0;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagezbspkindex = val;
      this.productlibrary();
    },
    handlegdChange(val) {
      this.data.pageNum = val;
    },
    //查询
    onSubmit() {
      if(this.zbradio=='first'){
        this.pagezbjindex = 1;
        this.getinit();
      }else{
        this.pagezbspkindex = 1;
        this.productlibrary();
      }
    },
    // 回显
    seeEcho(cardId){ // 直播房间ID
      roominfo('',this.bbid,cardId).then(data=>{
        if(data.resultCode == 1){
          let thisData = data.resultObj;
          this.cardId = thisData.roomid; // 直播间ID
          this.zhibojianbt = thisData.title; // 直播间标题
          this.kbTime = [thisData.starttime,thisData.endtime]; // 开播时间
          this.date3 = thisData.starttime; // 开始
          this.date4 = thisData.endtime; // 结束
          this.zhubonc = thisData.anchorname; // 主播名称
          this.zhubowxh = thisData.anchorwechat; // 主播微信号
          this.fubowxh = thisData.subanchorwechat; // 副播微信号
          this.zbjbjUrl = thisData.coverimg; // 直播间背景图 绝对路径(带域名)
          this.zbjshortUrl = thisData.coverimg.replace(localStorage.BaseOssUrl,'');
          this.fxtpUrl = thisData.shareimg; // 分享图片 绝对路径(带域名)
          this.fxtpshortUrl = thisData.shareimg.replace(localStorage.BaseOssUrl,'');
          this.sltpUrl = thisData.feedsimg; // 收录图片 绝对路径(带域名)
          this.sltpshortUrl = thisData.feedsimg.replace(localStorage.BaseOssUrl,'');
          this.checkedpl = thisData.opencomment==1?true:false; // 是否开通评论 0=否 1=是
          this.checkedfx = thisData.openshare==1?true:false; // 是否开通评分享0=否 1=是
          this.checkeddz = thisData.openlike==1?true:false; // 是否开通点赞 0=否 1=是
          this.checkedsphj = thisData.opengoods==1?true:false; // 是否开通商品货架 0=否 1=是
          this.checkedhf = thisData.openreplay==1?true:false; // 是否开通回放 0=否 1=是
          this.zbcommodityList = thisData.roomGoods; // 直播商品集合
        }
      })
    },
    // 创建直播间: 新增&编辑
    cjbjzbj(row){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      this.isShowzbj = false; // 隐藏tab列表页
      this.verificationsuccessOne = false;
      this.validationfailedOne = false;
      this.verificationsuccessTwo = false;
      this.validationfailedTwo = false;
      if(row){
        this.cardId = row.roomid; // 赋值选中行id-直播房间ID
        // var obj = {
        //   shopid: this.bbid, // 店铺ID
        //   roomId: this.cardId, // 直播房间ID
        // }
        this.seeEcho(row.roomid); // 回显数据
      }else{
        this.cardId = ""; // 新增进来 id置空
        this.zhibojianbt = ''; // 直播间标题
        this.kbTime = ''; // 开播时间
        this.zhubonc = ''; // 主播昵称
        this.zhubowxh = ''; // 主播微信号
        this.fubowxh = ''; // 副播微信号
        this.zbjbjUrl = ''; // 直播间背景
        this.zbjshortUrl = '';
        this.fxtpUrl = ''; // 分享图片
        this.fxtpshortUrl = '';
        this.sltpUrl = ''; // 收录图片
        this.sltpshortUrl = '';
        this.checkedpl = false; // 评论
        this.checkedfx = false; // 分享
        this.checkeddz = false; // 点赞
        this.checkedsphj = false; // 商品货架
        this.checkedhf = false; // 回放
        this.zbcommodityList = []; // 直播商品列表
      }
    },
    // 确定&取消 创建直播间
    handlezbj(val){
      if(val == 1){ // 确定
        if(this.zhibojianbt == ""){
          this.showAlert('请输入直播间标题');
          return false;
        }
        if(this.zhibojianbt.length<3){
          this.showAlert('直播间标题最短3个汉字，最长17个汉字');
          return false;
        }
        if(this.kbTime == ""){
          this.showAlert('请选择开播时间');
          return false;
        }
        if(this.zhubonc == ""){
          this.showAlert('请输入主播昵称');
          return false;
        }
        if(this.zhubonc.length<2){
          this.showAlert('主播昵称最短2个汉字，最长15个汉字');
          return false;
        }
        if(this.zhubowxh == ""){
          this.showAlert('请输入主播微信号');
          return false;
        }
        if(this.fubowxh == '') {
          this.showAlert('请输入副播微信号');
          return false;
        }
        if(this.zhubowxh == this.fubowxh){
          this.showAlert('主播和副播微信号不能是同一个');
          return false;
        }
        if(this.zbjshortUrl == ""){
          this.showAlert('请上传直播间背景');
          return false;
        }
        if(this.fxtpshortUrl == ""){
          this.showAlert('请上传分享图片');
          return false;
        }
        if(this.sltpshortUrl == ""){
          this.showAlert('请上传收录图片');
          return false;
        }
        if(this.verificationsuccessOne == false || this.verificationsuccessTwo == false){
          this.showAlert('请对主(副)播进行验证操作，验证通过后再进行其它操作');
          return false;
        }
        this.loadingBut = true;
        this.loadingButText = '提交中...';
        var obj = {
          roomid: this.cardId?Number(this.cardId):0, // 直播房间ID
          shopid: this.bbid, // 店铺ID
          title: this.zhibojianbt, // 直播间标题
          starttime: this.date3, // 开播时间（起始时间） 格式：yyyy-MM-dd HH:mm:ss
          endtime: this.date4, // 开播时间（截止时间） 格式：yyyy-MM-dd HH:mm:ss
          anchorname: this.zhubonc, // 主播昵称
          anchorwechat: this.zhubowxh, // 主播微信号
          subanchorwechat: this.fubowxh, // 副播微信号
          coverimg: this.zbjshortUrl, // 直播间背景 OSS相对路径
          shareimg: this.fxtpshortUrl, // 分享图片 OSS相对路径
          feedsimg: this.sltpshortUrl, // 收录图片 OSS相对路径
          opencomment: this.checkedpl==true?1:0, // 是否开通评论 0=否 1=是
          openshare: this.checkedfx==true?1:0, // 是否开通分享 0=否 1=是
          openlike: this.checkeddz==true?1:0, // 是否开通点赞 0=否 1=是
          opengoods: this.checkedsphj==true?1:0, // 是否开通商品货架 0=否 1=是
          openreplay: this.checkedhf==true?1:0, // 是否开启回放 0=关闭 1=开启
          listgoods: this.zbcommodityList.map(item=>item.goodsid), // 所选商品ID集合 opengoods=1时有效
          operatorid: localStorage.Id, // 操作人ID
        }
        let thisApi = this.cardId==''?roomadd:roomedit;
        thisApi(obj).then(data=>{
          if(data.resultCode == 1){
            this.showAlert('操作成功', 'success');
            this.isShowzbj = true;
            this.pagezbjindex = 1;
            this.getinit();
            this.loadingBut = false;
            this.loadingButText = '确定';
          }else if(data.resultCode == 2){ // 未认证
            this.showAlert(data.resultMsg);
            // this.seeEcho(data.resultObj); // 回显数据
            this.loadingBut = false;
            this.loadingButText = '确定';
          }else{
            this.showAlert(data.resultMsg);
            this.loadingBut = false;
            this.loadingButText = '确定';
          }
        })
      }else{ // 取消
        this.isShowzbj = true;
        this.pagezbjindex = 1;
        this.getinit();
      }
    },
    // 验证
    testing(val,type){
      let obj = {
        shopid: this.bbid, // 店铺ID
        nickname: this.searchsp, // 主播昵称 非必传
        wechatcode: val, // 微信号
        role: 2, // 成员角色，可以不传 默认2（1-管理员，2-主播，3-运营者）
        operatorid: localStorage.Id, // 操作人ID
      }
      memberadd(obj).then(data=>{
        if(data.resultCode == 1){
          this.showAlert('验证通过', 'success');
          if(type==1){
            this.verificationsuccessOne=true;
            this.validationfailedOne=false;
          }
          if(type==2){
            this.verificationsuccessTwo=true;
            this.validationfailedTwo=false;
          }
        } else {
          this.showAlert('验证未通过');
          if(type==1){
            this.validationfailedOne=true;
            this.verificationsuccessOne=false;
          }
          if(type==2){
            this.validationfailedTwo=true;
            this.verificationsuccessTwo=false;
          }
        }
      })
    },
    // 选择商品
    selectproduct(){
      this.shangpin=true;
      this.searchsp='';
      this.spList=this.spListAll.filter(i=>!this.zbcommodityList.find(ii=>i.goodsid == ii.goodsid));
    },
    // 选择商品列表
    getspList(){
      let addParams = {
        shopid: this.bbid, // 店铺ID
        goodsname: this.searchsp, // 商品名称
        status: 2,
        pageindex: this.pagexzspindex,// 分页数据 当前页码
        pagesize: 100 // 分页数据 每页显示条数
      };
      goodsgetlist(addParams).then(data => {
        this.spListAll = data.resultObj.list;
        // this.spxztotal = data.resultObj.totalcount;
      }).catch(err => {
        this.spListAll = [];
        // this.spxztotal = 0;
      });
    },
    // 分页
    changexzsp(val){
      this.pagexzspindex = val;
      this.getspList();
    },
    // 查询
    finddes(){
      this.getspList();
    },
    // 复选框
    handleselection(val) {
      this.selectedArr = [];
      val.forEach(element => {
        this.selectedArr.push({"goodsid":element.goodsid, "goodsname":element.goodsname, "price":element.price});
      });
    },
    // 确定-选择商品
    handlesp(){
      this.zbcommodityList = this.zbcommodityList.concat(this.selectedArr);
      this.shangpin = false;
    },
    // 删除
    shanchusp(index, rows){
      rows.splice(index, 1);
    },
    // 添加商品 & 编辑 & 修改价格 操作按钮
    addOrEditBrand(row,type) {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      // 如果有数据就是编辑 否则就是新增
      if (row) {
        this.cardId = row.goodsid;
        if(type==1){
          this.commodity = '编辑商品'; // 编辑商品
          this.seeDis = true;
        }
        if(type==2){
          this.commodity = '修改价格'; // 修改价格
          this.seeDis = false;
          this.brandName = row.ChannelName; // 商品名称
          this.anwser = row.Remark; // 价格
        }
        goodsinfo('',this.bbid,row.goodsid).then(data=>{
          if(data.resultCode == 1){
            let thisData = data.resultObj;
            this.cardId = thisData.goodsid; // 直播商品ID
            this.stateId = thisData.shopgoodsid; // 店铺橱窗商品ID
            this.brandName = thisData.goodsname; // 商品名称
            this.spfmUrl = thisData.goodsimg; // 直播商品图片 绝对路径
            this.spfmshortUrl = thisData.goodsimg.replace(localStorage.BaseOssUrl,'');
            this.resource = thisData.pricetype; // 价格类型
            if(this.resource==1){
              this.anwser = thisData.price; // 价格1 单位：元
            }
            if(this.resource==2){
              this.jgqjOne = thisData.price; // 价格1 单位：元
              this.jgqjTwo = thisData.price2; // 价格2 单位：元
            }
            if(this.resource==3){
              this.zkqjOne = thisData.price; // 价格1 单位：元
              this.zkqjTwo = thisData.price2; // 价格2 单位：元
            }
          }
        })
      } else {
        this.cardId = ""; // 新增进来 吧id置空
        this.commodity = '添加商品', // 添加商品
        this.seeDis = true;
        this.stateId = ''; // 清空商品id
        this.spfmUrl = ''; // 清空商品封面
        this.spfmshortUrl = '';
        this.brandName = ""; // 商品名称
        this.resource = 1, // 价格形式
        this.anwser = ""; // 价格
        this.jgqjOne = ""; // 价格区间-前
        this.jgqjTwo = ""; // 价格区间-后
        this.zkqjOne = ""; // 折扣区间-前
        this.zkqjTwo = ""; // 折扣区间-后
      }
      this.isToExamine = true; // 添加商品弹框
      this.getStatearr(); // 获取商品列表
    },
    // 提交审核 & 撤销审核
    cardStatus(row) {
      this.$swal({
        type: "warning",
        text: row.status == 1 ? "是否执行撤销审核操作" : "是否执行提交审核操作",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          var obj = {
            shopid: this.bbid, // 店铺ID
            goodsid: row.goodsid, // 直播商品ID
          }
          let thisApi = row.status==1?goodscancel:goodsaudit;
          thisApi(obj).then(data=>{
            if(data.resultCode == 1){
              this.productlibrary(); // 刷新商品库列表
              this.showAlert('操作成功', 'success');
            }
          })
        }
      });
    },
    // 单条删除-列表数据
    deleteBrand(row, type) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            shopid: this.bbid, // 店铺ID
            roomid: row.roomid, // 直播房间ID
            goodsid: row.goodsid, // 直播商品ID
          };
          let thisApi = type==1?roomdel:goodsdel;
          thisApi(obj).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('删除成功', 'success');
              if(type==1){
                this.pagezbjindex = 1;
                this.getinit();
              }else{
                this.pagezbspkindex = 1;
                this.productlibrary();
              }
            }
          });
        }
      });
    },
    // 确定按钮
    editSubmit() {
      if(this.stateId == ""){
        this.showAlert('请选择商品');
        return false;
      }
      if(this.brandName == ""){
        this.showAlert('请输入商品名称');
        return false;
      }
      if(this.resource == 1){
        if(this.anwser == ""){
          this.showAlert('请输入价格');
          return false;
        }
      }
      if(this.resource == 2){
        if(this.jgqjOne == ""||this.jgqjTwo == ""){
          this.showAlert('请输入价格区间');
          return false;
        }
        if(Number(this.jgqjOne) >= Number(this.jgqjTwo)){
          this.showAlert('左侧价格需要比右侧价格低');
          return false;
        }
      }
      if(this.resource == 3){
        if(this.zkqjOne == ""){
          this.showAlert('请输入市场价');
          return false;
        }
        if(this.zkqjTwo == ""){
          this.showAlert('请输入折扣价');
          return false;
        }
        if(Number(this.zkqjTwo) >= Number(this.zkqjOne)){
          this.showAlert('折扣价不能高于市场价');
          return false;
        }
      }
      // 判断是编辑还是新增
      var loginParams = {
        goodsid: this.cardId?this.cardId:0, // 直播商品ID
        shopid: this.bbid, // 店铺ID
        operatorid: localStorage.Id, // 操作人ID
        shopgoodsid: this.stateId, // 店铺橱窗商品ID
        goodsname: this.brandName, // 商品名称
        goodspic: this.spfmUrl.replace(localStorage.BaseOssUrl,''), // 商品图片地址 相对路径
        pricetype: this.resource, // 价格类型
        price: this.resource==1?this.anwser:this.resource==2?this.jgqjOne:this.zkqjOne,
        price2: this.resource==1?0:this.resource==2?this.jgqjTwo:this.zkqjTwo,
        submitaudit: this.checkedsp==true?1:0, // 是否提交审核 0=否 1=是 默认为0
      };
      let thisApi = this.cardId?goodsedit:goodsadd;
      thisApi(loginParams).then(data => {
        if (data.resultCode == 1) {
          // data = data.resultObj;
          this.showAlert('操作成功', 'success');
          this.isToExamine = false;
          this.productlibrary();
        }else{
          this.showAlert(data.resultMsg);
          return false;
        }
      }).catch(err => {
        this.showAlert(err, 'error');
        return false;
      });
    },
    // 查询商品
    getStatearr(){
      getshopgoods('',this.bbid).then(data=>{
        if(data.resultCode == 1){
          this.statearr = data.resultObj;
          // this.statearr.unshift({
          //   Id:0,
          //   Name:"全部"
          // })
        }
      })
    },
    changesp(val){
      this.statearr.filter(item => {
        if(item.shopgoodsid == val){
          this.spfmUrl = item.firstimg; // 带出对应图片
          // this.brandName = item.goodsname; // 带出 商品名称
        }
      })
    },
    // 直播间背景 & 分享图片 & 收录图片 & 商品封面
    beforUploadThree(file, type) {
      this.distinguish = type; // 区分
      if(type == 1){
        this.option.autoCropWidth = 600;
        this.option.autoCropHeight = 1300;
        this.option.fixedNumber = [600, 1300];
      }
      if(type == 2){
        this.option.autoCropWidth = 800;
        this.option.autoCropHeight = 640;
        this.option.fixedNumber = [800, 640];
      }
      if(type == 3){
        this.option.autoCropWidth = 800;
        this.option.autoCropHeight = 800;
        this.option.fixedNumber = [800, 800];
      }
      if(type == 4){
        this.option.autoCropWidth = 300;
        this.option.autoCropHeight = 300;
        this.option.fixedNumber = [300, 300];
      }
      const isJPG = file.type;
      if(type!=4&&isJPG !='image/jpeg'){
        this.showAlert('上传图片格式应为jpg');
        return false;
      }
      // 文件名检查
      
      // 定义允许的字符集，包括中文字符和其他常规字符
      const allowedChars = /^[\u4e00-\u9fa5a-zA-Z0-9._\-]+$/;
      // 检查文件名是否包含特殊字符
      if (!allowedChars.test(file.name)) {
        this.showAlert('文件名包含特殊字符，请重命名之后重新上传');
        return false;
      }
      
      // const specialCharPattern = /[\\/:*?"<>|]/;
      // if (specialCharPattern.test(file.name)) {
      //   this.showAlert('文件名包含特殊字符，请重命名之后重新上传');
      //   return false;
      // }

      // const allowedChars = /^[a-zA-Z0-9._\-]+$/; // 允许字母、数字、点、下划线、连字符
      // const fileName = file.name;
      // if (!allowedChars.test(fileName)) {
      //   this.showAlert('文件名包含特殊字符，请重命名之后重新上传');
      //   return false;
      // }

      this.fileinfo = file;
      const isSize = new Promise(function (resolve, reject) {
        let width = type==1?600:type==2?800:type==3?800:type==4?300:600;
        let height = type==1?1300:type==2?640:type==3?800:type==4?300:1300;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function (e) {
          var obj = { type: 11 };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          if(type == 1) { // 直播间背景
            that.zbjbjUrl = newOssPic; // 全链接
            that.zbjshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          if(type == 2) { // 分享图片
            that.fxtpUrl = newOssPic; // 全链接
            that.fxtpshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          if(type == 3) { // 收录图片
            that.sltpUrl = newOssPic; // 全链接
            that.sltpshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          if(type == 4) { // 商品封面
            that.spfmUrl = newOssPic; // 全链接
            that.spfmshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          that.cropping = false; // 图片裁剪弹框
        };
      },() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // 上传成功后将图片地址赋值给裁剪框显示图片
          that.$nextTick(() => {
            that.option.img = e.target.result
            that.cropping = true; // 图片裁剪弹框
            if(type == 1) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("600 x 1300")
                document.querySelector('.crop-info').innerHTML = '600 x 1300'
              },300)
            }
            if(type == 2) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("800 x 640")
                document.querySelector('.crop-info').innerHTML = '800 x 640'
              },300)
            }
            if(type == 3) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("800 x 800")
                document.querySelector('.crop-info').innerHTML = '800 x 800'
              },300)
            }
            if(type == 4) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("300 x 300")
                document.querySelector('.crop-info').innerHTML = '300 x 300'
              },300)
            }
          })
          return
        };
        // this.showAlert(type==1?"上传图片宽高应为600*1300":type==2?'上传图片宽高应为800*640':type==3?"上传图片宽高应为800*800":type==4?"上传图片宽高应为300*300":'上传图片宽高应为600*1300');
      });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var fileName = this.fileinfo.name; // 获取文件名称
        var canvas=document.getElementById("canvasa");
        var ctx=canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img=new Image();
        img.onload=start;
        img.src=_URL.createObjectURL(data);
        function start(){
          canvas.width=that.distinguish==1?600:that.distinguish==2?800:that.distinguish==3?800:that.distinguish==4?300:600;
          canvas.height=that.distinguish==1?1300:that.distinguish==2?640:that.distinguish==3?800:that.distinguish==4?300:1300;
          var w=img.width;
          var h=img.height;
          var sizer=Math.min((canvas.width/w),(canvas.height/h));
          ctx.drawImage(img,0,0,w,h,0,0,w*sizer,h*sizer);
          var dataURL = canvas.toDataURL('image/jpeg');
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            // return new File([u8arr], filename, {type:mime});
            return new File([u8arr], fileName, {type:mime});
          }
          var file = dataURLtoFile(dataURL)
          that.beforUploadThree(file, that.distinguish)
        }
      })
    },
    changetimeOne() {
      if (this.valuedate + "" == "null") {
        this.valuedate = ["", ""];
      }
      this.date1 = this.valuedate[0];
      this.date2 = this.valuedate[1];
    },
    changetimeTwo() {
      if (this.kbTime + "" == "null") {
        this.kbTime = ["", ""];
      }
      this.date3 = this.kbTime[0];
      this.date4 = this.kbTime[1];
    },
    // 开播码
    handlekbm(row){
      this.kbmUrl = row.qrcodeurl; // 开播码图片路径 绝对路径
      this.kaiboma = true; // 弹框显示
    },
    // 分享
    handlefx(row){
      // this.fenxiang = true; // 弹框显示
      roomshare('',this.bbid,row.roomid).then(data=>{
        if(data.resultCode == 1){
          let thisUrl = data.resultObj;
          this.fxhb = thisUrl.posterurl; // 分享海报 绝对路径
          window.open(this.fxhb);
        }
      })
    },
    // 下载二维码图片
    handDown(url){
      window.open(url);
    },
    // 控制台 跳转
    handlekzt() {
      window.open('https://live.weixin.qq.com/livemp/login');
    },
    // 请选择店铺
    initshop(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else {
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id;     //店铺id
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺。');
            return false;
          }
        }
      })
    },
    gonext(){
      console.log(this.bbid)
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false;
      }
      this.getinit(); // 初始化查询列表
      this.dialogVisibleadd = false;
      this.getspList();
    },
  },
  created() {
    this.initshop(); // 初始化弹框
  }
}
</script>
<style scoped>
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
  /* margin: 5px 10px 5px 0; */
}
.el-table::before {
  z-index: inherit;
}
</style>


// WEBPACK FOOTER //
// livebroadcast.vue?2af6ecde